// App asset symbol → most likely MT5 broker ticker.
// MT5 brokers name instruments differently from our ASSETS; this maps the
// common commodities/indices/crypto. Equities (US + Thai SET on Pi) usually
// match the plain ticker, so the default is the symbol itself.
const MT5_ALIAS: Record<string, string> = {
  GOLD: 'XAUUSD',
  WTI: 'USOIL',
  SPX: 'US500',
  NDX: 'US100',
  DJI: 'US30',
  BTC: 'BTCUSD',
  ETH: 'ETHUSD',
  SOL: 'SOLUSD',
};

/** Best-guess MT5 symbol for one of our ASSETS. */
export function mt5Symbol(asset: { sym: string }): string {
  return MT5_ALIAS[asset.sym] || asset.sym;
}
